import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import * as TypeInfo from '@/Utility/TypeInfo';
import ColumnLayoutViewModel from '@/ViewModels/Controls/ColumnLayoutViewModel';
import AssociationGridFactory from '@/Factories/ControlFactories/AssociationGridFactory';

export default class AutoTwoColumnLayoutViewModel extends ControlViewModel {

    private rightColumnFactories = ['AssociationGridFactory']
    private ColumnLayoutViewModel = ComponentManager.getViewModel<typeof ColumnLayoutViewModel>('ColumnLayoutViewModel');

    /**
     * Die Factory-Tuples
     */
    public tuples: any[];

    /**
     * Beinhaltet und verändert die Breite der LabelColumn
     */
    public labelColumnWidth: KnockoutObservable<number | string>;

    /**
     * Das innere ColumnLayout (links)
     */
    public columnLayoutLeft: ColumnLayoutViewModel;

    /**
     * Das innere ColumnLayout (rechts)
     */
    public columnLayoutRight: ColumnLayoutViewModel;

    /**
     * Das ViewModel für die AutoTwoColumnLayout
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.tuples = this.paramOrDefault(params.tuples, []);
        this.labelColumnWidth = this.observableOrDefault(params.labelColumnWidth, 200);

        this.columnLayoutLeft = new this.ColumnLayoutViewModel({
            columnsPerRow: 1,
            labelColumnWidth: this.labelColumnWidth,
            tuples: ( () => {
                let tuples = this.tuples;
                let result = [];

                for (let i = 0; i < tuples.length; i++) {
                    let inRightColumn = false;
                    let factory = TypeInfo.getType(tuples[i].factory);

                    if (this.rightColumnFactories.indexOf(factory) > -1) {
                        inRightColumn = true;
                    }

                    if (inRightColumn === false) {
                        result.push(tuples[i]);
                    }
                }

                return result;
            })()
        });

        this.columnLayoutRight = new this.ColumnLayoutViewModel({
            columnsPerRow: 1,
            labelColumnWidth: this.labelColumnWidth,
            tuples: ( () => {
                let tuples = this.tuples;
                let result = [];

                for (let i = 0; i < tuples.length; i++) {
                    let inRightColumn = false;
                    let factory = TypeInfo.getType(tuples[i].factory);

                    if (this.rightColumnFactories.indexOf(factory) > -1) {
                        inRightColumn = true;
                    }

                    if (inRightColumn === true) {
                        result.push(tuples[i]);
                    }
                }

                return result;
            })()
        });
    }
}

ComponentManager.setViewModel('AutoTwoColumnLayoutViewModel', AutoTwoColumnLayoutViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');